import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { setLanguage } from "@/i18n";
import { useAuth } from "@/contexts/AuthContext";
import { SettingsCard, ChoiceButton, useSaveProfile } from "./primitives";

/**
 * LanguageSection — EN/ES toggle. `setLanguage` applies i18next
 * immediately (no reload) then we persist the preference server-side.
 */
export default function LanguageSection() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { saveProfile } = useSaveProfile();

  const onChangeLanguage = (value) => {
    if (!value || value === user?.language) return;
    setLanguage(value);
    saveProfile({ language: value }, t("settings.languageSaved"));
  };

  return (
    <SettingsCard
      icon={<Languages className="w-4 h-4" strokeWidth={1.5} />}
      title={t("settings.languageTitle")}
      help={t("settings.languageHelp")}
    >
      <div role="radiogroup" aria-label={t("settings.languageTitle")} className="grid grid-cols-2 gap-2">
        <ChoiceButton
          active={(user?.language || "en") === "en"}
          onClick={() => onChangeLanguage("en")}
          testId="lang-en"
        >
          English
        </ChoiceButton>
        <ChoiceButton
          active={user?.language === "es"}
          onClick={() => onChangeLanguage("es")}
          testId="lang-es"
        >
          Español
        </ChoiceButton>
      </div>
    </SettingsCard>
  );
}
